export default {
	container: {
		center: true,
		padding: {
			DEFAULT: "1.5rem",
			lg: "1.875rem",
		},
	},
	extend: {
		fontFamily: {
			lato: ["Lato", "sans-serif"],
			"marcellus-sc": ["Marcellus SC", "serif"],
		},
		screens: {
			0: "425px",
			sm: "640px",
			md: "768px",
			lg: "1024px",
			xl: "1280px",
			"2xl": "1440px",
			"lg-down": {
				max: "1330px",
			},
			"md-down": {
				max: "1024px",
			},
			"sm-down": {
				max: "768px",
			},
			"sm-only": {
				max: "670px",
			},
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			"audhali-a": "#202E8E",
			"audhali-b": "#7885DE",
			"audhali-c": "#0A1561",
			"audhali-d": "#F4F2F0",
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
	},
};
